import { derivedDiagramState, diagram } from '@diagram/state/diagram';

import { useSnapshot } from 'hooks/use-safe-snapshot';

const useDiagram = () => {
    return useSnapshot(diagram);
};

const useDerivedDiagram = () => {
    return useSnapshot(derivedDiagramState);
};

export { useDiagram, useDerivedDiagram };
